import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {getDeletedGuestDatas, hardDeleteGuestData, restoreGuestData,} from "../../../redux/modules/Guest/action";

class GuestTrash extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getDeletedGuestDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.guest.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const guestColumn = [
            {
                name: "Guest",
                path: "name",
                show: true,
            },
            {
                name: "Location",
                path: "location",
                show: true,
            },
            {
                name: "Gender",
                path: "gender",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"Guest Category Data"}
                        data={this.props.guest.datas}
                        columns={guestColumn}
                        trashAction={true}
                        deleteAction={(id) => this.props.hardDeleteGuestData(id)}
                        restoreAction={(id) => this.props.restoreGuestData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    guest: state.guest,
});

const mapDispatchToProps = {
    getDeletedGuestDatas,
    hardDeleteGuestData,
    restoreGuestData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(GuestTrash)
);
